const NO_AUTH_API = [
    '/oauth',
    '/users/headquarters',
    '/permission/',
    'assets',
    'on-signup',
    'download.cameconnect.net/servicestatus/frontend',
    '/app-firmware',
];

// exeptions
// - /oauth/a2al
// - /oauth/technicians
// - /oauth/delete/user
const NO_AUTH_EXCEPTIONS = [
    '/oauth/delete/user'
];

export const noAuthApi = (url: string): boolean => {
    let res = NO_AUTH_EXCEPTIONS.map(api => url.includes(api));
    if (res.some(r => !!r)) {
        return false; // requires auth
    }
    res = NO_AUTH_API.map(api => url.includes(api));
    return res.some(r => !!r);
};
